const DENTAL_VISION = '/dental-vision/'
const DENTAL_VISION_EXTERNAL = '/dental-vision-external/'
const DENTAL_VISION_LITE5 = '/dental-vision-lite5/'

function detectBasePath(): string {
  if (typeof window !== 'undefined') {
    const uri = window.location.pathname
    if (uri.startsWith(DENTAL_VISION_EXTERNAL)) return DENTAL_VISION_EXTERNAL
    if (uri.startsWith(DENTAL_VISION_LITE5)) return DENTAL_VISION_LITE5
  }
  return DENTAL_VISION
}

export function getBasePath(): string {
  return detectBasePath()
}

export function withBase(path: string): string {
  const base = getBasePath()
  const absolute = path.startsWith('/') ? path : `/${path}`
  if (base === '/') return absolute
  if (absolute.startsWith(base)) return absolute
  return `${base}${absolute.slice(1)}`
}
